'use strict'

/**
 *
 * @name: nnExperimentsModal
 *
 */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
// import moment from 'moment-timezone'

import DirectiveTemplate from './nn-experiments-modal.directive.html'
import './nn-experiments-modal.directive.scss'

function NnExperimentsModalDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    controller: nnExperimentsModalDirectiveController
  }
}

function nnExperimentsModalDirectiveController ($scope, $rootScope, $element) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

  $scope.isOpened = true


  /*
   *
   * @PUBLIC
   *
   */

  $scope.close = e => {
    e.preventDefault()
    $scope.isOpened = false
    enableBodyScroll($element[0]);
  }

  $scope.isRightTime = () => {
    // const time = moment.tz('Asia/Shanghai').format('DMHHmm')
    // return time > 6112300
    return true
  }

  $scope.showModal = () => {
    return $scope.isOpened && $rootScope.lang === 'zh-cn' && $scope.isRightTime()
  }


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */

  if ($scope.showModal()) {

    disableBodyScroll($element[0]);
  }

}

export default NnExperimentsModalDirective



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-experiments-modal/nn-experiments-modal.directive.js